( function () {
   
    'use strict';

    ( function ( $ ) {
        var ppp = 12; // Post per page
        var pageNumber = 2;
        if( $('.news-list-tab').length > 0 ) {     
        const storedPraferance = $.cookie('wps_praferance');
        if (storedPraferance) {
            $(".buytickets-tab-list").click(function () {
              
                if ($(this).hasClass('active')) {
                } else {
                    pageNumber = 1;
                    $(".buytickets-tab-list").removeClass('active');
                    $(this).addClass('active');
                    var cat = $(this).find('a').data("id");
                    getnewslist(cat,false);                
                }
                return false;
            });
            if (storedPraferance === 'women') {
                $(".buytickets-tab-list a[data-id='womens']").parent().trigger('click');            
            }
            else{
                $(".buytickets-tab-list a[data-id='all']").parent().trigger('click');    
            }
        }
        // if( $('.news-list-tab').length > 0 ) {     
        //     $(".buytickets-tab-list").click(function () {
        //         pageNumber = 1;
        //         if ($(this).hasClass('active')) {
        //         } else {
        //             $(".buytickets-tab-list").removeClass('active');
        //             $(this).addClass('active');
        //             var cat = $(this).find('a').data("id");
        //             getnewslist(cat,false);                
        //         }
        //         return false;
        //     });
        }
       
        $('form.search-news-form').on('submit', function(e) {
            e.preventDefault();
            pageNumber = 1;
            var catslug = $('.news-tab ul li.active').find('a').data("id");
            var text = $('#nsercdata').val();
            getnewslist(catslug,false,text);
        });

        $('.load-more-news').on('click',function(e){
            e.preventDefault();
            var catslug = $('.news-tab ul li.active').find('a').data("id");
            getnewslist(catslug,true);
        });

        function getnewslist(cat,isAppend=false,texts='') {
            var catslug = cat;
            var texts = texts;
            //alert(catslug);
            if(catslug != ''){
                $(".loaders").show();
                $.ajax({
                    type: "GET",
                    cache: false,
                    url: ssAjax.ajaxurl,
                    data: { nonce: ssAjax.nonce, catslug:catslug,texts:texts, action: 'getnewslists', ppp: ppp, pageNumber:pageNumber },
                    dataType: 'json',
                    success: function (responses) {
                      //  console.warn(responses);
                        $(".loaders").fadeOut();
                        if(pageNumber >= responses.max) {
                            $('.loadmore-news-wrap').hide();
                        }
                        else{
                            $('.loadmore-news-wrap').show();
                        }
                        if(!isAppend){
                            $("#printdatas").html("");
                            $("#printdatas").html(responses.html);
                        }
                        else{
                            $("#printdatas").append(responses.html);
                        }
                        pageNumber++;
                    }
                });
            }
        }
        //Initially call to fetch news
        //getnewslist('all',false);
    } )( jQuery );
} )();

